import { push } from "../Services/Analytics"

var textToShare = "תמיד אמרו שהיכולת האינטואטיבית של בני האדם מבטיחה שתמיד נהיה חכמים יותר מהטכנולוגיה. אבל אז המכשירים מסביבנו התחילו להרגיש";
var urlToShare = "https://z.ynet.co.il/short/commerce/2018/poweredbylg/";

const shareFacebook = () => {
    push("Share_Facebook", urlToShare);
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare), "_blank");
}

const shareTwitter = () => {
    push("Share_Twitter", urlToShare);
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(urlToShare), "_blank");
}

const shareWhatsapp = () => {
    push("Share_WhatsApp", urlToShare);
    window.open("whatsapp://send?text=" + encodeURIComponent(textToShare + " >> " + urlToShare), "_parent");
}

const openNegishut = () => {
    push("Accessibility", "Open_Accessibility_Clicked");
    window.document.getElementById('INDmenu-btn').click();
}

export {
    shareFacebook,
    shareTwitter,
    shareWhatsapp,
    openNegishut
}


// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js